export enum WorkWithUsDataTestId {
  WORK_WITH_US_CONTAINER_OUR_OPPORTUNITIES = 'work-with-us--container-our-opportunities',
  WORK_WITH_US_BUTTON_VIEW_OPPORTUNITIES = 'work-with-us--button-view-opportunities',
  WORK_WITH_US_BUTTON_BECOME_OUR_PARTNER = 'work-with-us--button-become-our-partner',
  WORK_WITH_US_BUTTON_CHECK_OPPORTUNITIES = 'work-with-us--button-check-opportunities',
}
